import { styled } from '@uhg-abyss/web/tools/styled';

import { mobileOnly, notMobile } from '../../ConstantsStyles';

export const Input = styled('input', {
  border: 'none !important',
  fontSize: 18,
  fontFamily: '$primary',
  outline: 'none',
  padding: '0px',
  // Prevent text overflow with vertical divider: 40px for desktop, 16px for mobile
  paddingRight: '40px',
  width: '100%',
  '@media (max-width: 744px)': {
    paddingRight: '16px',
  },
  '&:focus': {
    boxShadow: 'none !important',
    textOverflow: 'ellipsis',
  },
  '&:focus-visible': {
    boxShadow: 'none !important',
  },
  '&.allyFocusWithin:focus': {
    boxShadow: 'none !important',
  },
  textOverflow: 'ellipsis',
  '&::placeholder': {
    fontSize: '18px',
    fontStyle: 'italic',
    lineHeight: '24px',
  },
});

export const KeywordSearchStyledDiv = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  [`@media ${mobileOnly}`]: {
    paddingTop: '4px',
  },
  '#initInstr': {
    display: 'none',
  },
});

export const KeywordSearchLabel = styled('label', {
  dynamic: ({ cssProps: { isGEHAV2 } = {} }) => ({
    color: isGEHAV2 ? '$core.color.brand.100' : '$core.color.neutral.80',
  }),
  fontSize: '12.64px',
  fontWeight: 700,
  lineHeight: '16px',
});

export const KeywordSearchInputContainer = styled('div', {
  display: 'flex',
  flex: 3,
  flexDirection: 'column',
  [`@media ${notMobile}`]: {
    gap: '4px',
    marginRight: '407px',
  },
});

export const DarkeningOverlay = styled('div', {
  background: 'rgba(0, 0, 0, 0.2)',
  height: '100%',
  left: 0,
  position: 'fixed',
  top: 0,
  width: '100%',
  zIndex: 1,
});

export const SearchPlacementStyle = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  padding: `8px 20px`,
});

export const InputBox = styled('div', {
  alignSelf: 'flex-start',
  backgroundColor: 'white',
  border: `1px solid $searchBorderColor`,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
  left: 0,
  right: 0,
  top: 0,
  width: '100%',
  zIndex: 1,
  [`@media ${notMobile}`]: {
    borderRadius: '36px',
  },
  [`@media ${mobileOnly}`]: {
    borderRadius: '30px',
  },
  variants: {
    hasShadow: {
      true: {
        boxShadow: 'rgba(0, 0, 0, 0.10) 0px 4px 8px 0px ',
        overflow: 'hidden',
      },
    },
    isSharpBottomRightCorner: {
      true: {
        '&&': {
          borderBottomRightRadius: '0px',
        },
      },
    },
    mobileScreen: {
      true: {
        position: 'relative',
      },
      false: {
        position: 'absolute',
      },
    },
  },
});

export const PositioningBox = styled('div', {
  minHeight: '62px',
  zIndex: '9',
  marginBottom: '24px',
  position: 'relative',
  width: '100%',
  paddingRight: '$lg',
  [`@media ${mobileOnly}`]: {
    display: 'flex',
    marginBottom: 0,
    zIndex: 2,
    height: 'auto !important',
  },
  [`@media (${mobileOnly}) and (max-height: 450px)`]: {
    zIndex: 0,
  },
});

export const LocationInputContainer = styled('div', {
  display: 'flex',
  marginLeft: '24px',
  position: 'absolute',
  right: '20px',
  top: '0',
  width: '407px',
  zIndex: 1,
  [`@media ${mobileOnly}`]: {
    display: 'none',
  },
});

export const LocationInputRow = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  marginLeft: '24px',
  position: 'absolute',
  right: '24px',
  top: '12px',
  width: '407px',
});

export const LocationSearchPieceContainer = styled('div', {
  display: 'flex',
  flex: 1,
  [`@media ${notMobile}`]: {
    flexDirection: 'column',
    gap: '4px',
  },
  [`@media ${mobileOnly}`]: {
    display: 'none',
  },
  variants: {
    isShowingLocationDropdown: {
      true: {
        marginLeft: '25px',
        marginRight: '24px',
      },
      false: {
        marginLeft: '24px',
        marginRight: '24px',
      },
    },
  },
});

export const A11yHiddenSpan = styled('span', {
  border: '0',
  clip: 'rect(0 0 0 0)',
  clipPath: 'polygon(0px 0px, 0px 0px, 0px 0px)',
  '-webkit-clip-path': 'polygon(0px 0pxm 0px 0px, 0px 0px)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: '0',
  position: 'absolute',
  width: '1px',
  whiteSpace: 'nowrap',
});

export const LocationSearchPiece = styled('div', {
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  '#initInstrLocation': {
    display: 'none',
  },
});

export const LocationSearchLabel = styled('label', {
  dynamic: ({ cssProps: { isGEHAV2 } = {} }) => ({
    color: isGEHAV2 ? '$core.color.brand.100' : '$core.color.neutral.80',
  }),
  fontSize: '12.64px',
  fontWeight: 700,
  lineHeight: '16px',
});

export const InputDivider = styled('div', {
  backgroundColor: '$lightGray',
  margin: '0px',
  width: '1px',
  [`@media ${mobileOnly}`]: {
    display: 'none',
  },
});

export const IconContainer = styled('div', {
  height: '24px',
  marginBottom: 'auto',
  marginRight: '8px',
  marginTop: 'auto',
  width: '24px',
});
